$(document).ready(function() {
  if ($(".announcement-bar__close-button").length > 0) {
    let close_btns = $(".announcement-bar__close-button");
    
    close_btns.each((index, close_btn) => {
      let parent_section = $(close_btn).closest(".section-announcement");

      
      $(close_btn).on("click", () => {
				parent_section.hide();
				document.body.classList.add("announcement-hide");
			});
    });
  }
});

/* Rotating announcement messages (2+ messages, ticker off) */
(function () {
  if (window.customElements.get('announcement-rotator')) return;

  class AnnouncementRotator extends HTMLElement {
    constructor() {
      super();
      this.slides = Array.from(this.querySelectorAll('[data-rotator-slide]'));
      this.index = Math.max(0, this.slides.findIndex(function (s) { return s.classList.contains('is-active'); }));
      this.interval = parseInt(this.dataset.interval, 10) || 5000;
      this.timer = null;
      this.reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (this.slides.length < 2) return;

      var prev = this.querySelector('[data-rotator-prev]');
      var next = this.querySelector('[data-rotator-next]');
      if (prev) prev.addEventListener('click', this.prev.bind(this));
      if (next) next.addEventListener('click', this.next.bind(this));

      this.addEventListener('mouseenter', this.stop.bind(this));
      this.addEventListener('mouseleave', this.start.bind(this));
      this.addEventListener('focusin', this.stop.bind(this));
      this.addEventListener('focusout', this.start.bind(this));

      document.addEventListener('visibilitychange', function () {
        document.hidden ? this.stop() : this.start();
      }.bind(this));

      // Theme editor: show the block being edited and hold there
      if (window.Shopify && Shopify.designMode) {
        document.addEventListener('shopify:block:select', function (e) {
          var i = this.slides.indexOf(e.target);
          if (i > -1) { this.stop(); this.show(i); this.editing = true; }
        }.bind(this));
        document.addEventListener('shopify:block:deselect', function (e) {
          if (this.slides.indexOf(e.target) > -1) { this.editing = false; this.start(); }
        }.bind(this));
      }

      this.show(this.index);
      this.start();
    }

    disconnectedCallback() { this.stop(); }

    show(i) {
      var count = this.slides.length;
      var nextIndex = ((i % count) + count) % count;
      var current = this.slides[this.index];
      var target = this.slides[nextIndex];
      if (current !== target) {
        current.classList.remove('is-active');
        current.classList.add('is-leaving');
        window.setTimeout(function () { current.classList.remove('is-leaving'); }, 600);
      }
      target.classList.add('is-active');
      this.index = nextIndex;
    }

    next() { this.show(this.index + 1); this.restart(); }
    prev() { this.show(this.index - 1); this.restart(); }

    start() {
      if (this.timer || this.editing || this.slides.length < 2) return;
      this.timer = window.setInterval(function () { this.show(this.index + 1); }.bind(this), this.interval);
    }
    stop() {
      if (this.timer) { window.clearInterval(this.timer); this.timer = null; }
    }
    restart() { this.stop(); this.start(); }
  }

  window.customElements.define('announcement-rotator', AnnouncementRotator);
})();
